/**
 * Top bar component for transactions
 * 
 * Properties:
 * 
 *      textLeft:   string, text to be displayed at left side
 *      refLabel:   string, label for link to print closing
 *      amount:     number, representing saldo
 *      handler:    function, callback to trigger by clicking on ref
 */

import React, { useRef } from "react";
import t from '../../../helpers/t';
import { FormatHelper, Biscuit } from "../../../../utils";
import {Abschluss} from "./Abschluss";
import ReactToPrint, {PrintContextConsumer, useReactToPrint} from 'react-to-print';
import {getDocHandler} from "../../../../utils/Helper";
import moment from "moment/moment";

const AdminTransactionsTopBar = (props) => {
    const { textLeft, handler, refLabel, amount, getComplete, getCompletePending, clients, filter } = props;
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const handleGetTransactions = () => {
        let begin = moment("1970-01-01").format('YYYY-MM-DD 23:59:59');
        let end = moment().format('YYYY-MM-DD 23:59:59');
        if(typeof filter.date_gte !== 'undefined'){
            begin = filter.date_gte;
        }
        if(typeof filter.date_lte !== 'undefined'){
            end = filter.date_lte;
        }
        let body = {
            from: begin,
            to: end
        };
        if(typeof filter.client_id !== 'undefined'){
            body.client_id = filter.client_id;
        }
        let dateString = '';
        if(typeof filter.date_gte !== 'undefined'){
            dateString += moment(filter.date_gte).format('DD.MM.YYYY');
        }
        if(typeof filter.date_lte !== 'undefined' && typeof filter.date_gte !== 'undefined'){
            dateString += ' - ' + moment(filter.date_lte).format('DD.MM.YYYY');
        }
        getDocHandler('/payments/getAdminTransactionsPDF','POST','application/pdf',(filter?.client_id?clients[filter?.client_id]:"Alle Clients")+" "+dateString+'.pdf','',null,body);
    }
    return (
        <div style={{width: "100%",height: "50px", paddingTop: "3px", borderBottom: "1px solid rgb(227, 227, 227)", fontSize: "0.85em", fontWeight: "bold"}}>
            <div className="inb-c-item-details-row row" style={{paddingRight: '0px'}}>
                <div className="medium-4 small-4 column">
                    <span>{textLeft}</span>
                </div>
                <div className="medium-4 small-4 column text-center">
                    {clients !== null ? <>
                        <div>
                            {/*<div style={{ display: "none" }}> <Abschluss
                                complete={getComplete}
                                clients={clients}
                                filter={filter}
                                ref={componentRef}
                            /></div>*/}
                            <a href='#' onClick={handleGetTransactions}>{refLabel}</a>
                            </div>
                            </>:<>
                            <span><img alt="RollingLoader" className="rollingLoader colorize-black"
                                       src={"assets/img/rolling_loader.svg"}/> </span>
                    </>
                    }
                </div>
                <div className="medium-4 small-4 column text-right">
                    {getComplete !== null && !getCompletePending ?<> <span>{FormatHelper.currencyFormat(getComplete.sumAll) + " " + Biscuit.get('client.currency')}</span></>
                        :<>
                            <span><img alt="RollingLoader" className="rollingLoader colorize-black"
                                       src={"assets/img/rolling_loader.svg"}/> </span>
                        </>
                    }
                </div>
            </div>
        </div>
    );
};
export default AdminTransactionsTopBar;